import { Dialog, ListItemIcon, Menu, MenuItem, Button, DialogActions, DialogContent, DialogTitle, Link, Paper, TextField, Typography, ListItem, Select, FormControl, InputLabel, List, ListItemText, ListItemSecondaryAction, ListItemButton, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Stack } from "@mui/material";
import { Delete, DeleteOutline, Logout, Settings } from '@mui/icons-material'
import { add, format, set } from 'date-fns'
import { useEffect, useRef, useState } from 'react'
import {useGlobal} from 'reactn'
import { Bereichsauswahl } from "./utils";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useNavigate } from "react-router";
import '@sweetalert2/theme-material-ui/material-ui.css';
import './user.css'
import { unregister } from "./serviceWorkerRegistration";


const swal = withReactContent(Swal)



export function MenuDing({version}) {
    const [axios] = useGlobal('axios')
    const [cmeswitch,setCmeswitch] = useGlobal('cmeswitch')
    const [menu,setMenu] = useState(null)
    const [standalone,setStandalone] = useState(false)
    
    const [settings,setSettings] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        setStandalone(isInstalled())
    },[])

    function isInstalled() {
        // For iOS
        if(window.navigator.standalone) return true
        // For Android
        if(window.matchMedia('(display-mode: standalone)').matches) return true      
        // If neither is true, it's not installed
        return false
      }


    const logout = () => {
        setMenu(null)
        axios.post('logout').then(res => axios.post('login',{username:'',password:''}))
      }

    const opensettings = (v) => {
        setMenu(null)
        setSettings(v)
    }

    const clearCacheData = () => {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
      };

    const forced_reload = () => {
        unregister();
        clearCacheData();
        window.location.reload(true);
    }

    const close = () => {
        window.close()
    }

    return (
        <div className='topright'>
            <Settings onClick={e => setMenu(e.currentTarget)}/>
            <Menu open={Boolean(menu)} onClose={e => setMenu(null)}  anchorEl={menu} anchorOrigin={{vertical: 'top',horizontal: 'right',}} transformOrigin={{vertical: 'top',horizontal: 'right',}}>
                <MenuItem onClick={e => opensettings('settings')} >
                    <ListItemIcon>
                        <Settings fontSize='small'/>
                        Einstellungen
                    </ListItemIcon>
                </MenuItem>
                {/* <MenuItem onClick={e => opensettings('bescheinigungen')}> */}
                <MenuItem onClick={e => {setMenu(null);setCmeswitch(true);navigate('fortbildungen')}}>
                    <ListItemIcon>
                        Bescheinigungen
                    </ListItemIcon>
                </MenuItem>
                <MenuItem onClick={e => logout()}>
                    <ListItemIcon>
                        <Logout fontSize='small'/>
                        Abmelden
                    </ListItemIcon>
                </MenuItem>
                {standalone && <MenuItem onClick={e => close()}>
                    <ListItemIcon>
                        <Logout fontSize='small'/>
                        Schließen
                    </ListItemIcon>
                </MenuItem>    
                }
                <Typography variant="caption" className='versioninfo' style={{cursor:'pointer'}} onDoubleClick={e => forced_reload()} >v{version}</Typography>
            </Menu>
            {settings === 'settings' && <UserSettings open={settings ==='settings'} close={e => setSettings(false)}/>}
            {settings === 'bescheinigungen' && <Bescheinigungen open={settings === 'bescheinigungen'} close={e => setSettings(false)}/>}
        </div>
    )

}


function UserSettings({open,close}) {
    const [axios] = useGlobal('axios')
    const [userdata,setUserdata] = useState({})
    const [pw2,setPw2] = useState('')
    const [notvalid,setNotvalid] = useState(true)

    useEffect(() => {
        if (open) 
            axios.get('userdata').then(data => {
                setUserdata({...data.data})
                setTimeout(() => setNotvalid(true),500)
            })
    },[open])

    useEffect(() => {
        setNotvalid((userdata.password && userdata.password !== pw2) || !userdata.name?.vorname || !userdata.name?.nachname || !userdata.mobile)
    },[userdata,pw2])

    const handleChangeSettings = () => {
        axios.post('updateuser',{...userdata}).then(r => {
            swal.fire({
          text : 'Daten geändert',
         confirmButtonText: 'ok',
          })
         close()
        })
    }

    return (
        <Dialog open={open}>
        <DialogTitle>Benutzerdaten</DialogTitle>
        <DialogContent>
            <Stack spacing={2} sx={{mt:1}}>
                <TextField disabled label="Email-Adresse" value={userdata.email || ''} fullWidth/>
                <Stack direction={{xs:'column', sm:'row'}} spacing={2}>
                    <TextField label="Neues Passwort" value={userdata?.password || ''} type='password' fullWidth autoComplete='new-password' onChange={e => setUserdata({...userdata,password:e.target.value})}/>
                    <TextField label="Passwort wiederholen" error={!!userdata?.password && pw2 !== userdata.password} value={pw2} type='password' fullWidth autoComplete='new-password' onChange={e => setPw2(e.target.value)}/>
                </Stack>
                <Stack direction={{xs:'column', sm:'row'}} spacing={2}>
                    <FormControl sx={{minWidth:110}}>
                        <InputLabel>Anrede</InputLabel>
                        <Select value={userdata?.anrede || ''} label='Anrede' onChange={e => setUserdata({...userdata,anrede:e.target.value})}>
                            <MenuItem value={'Herr'}>Herr</MenuItem>
                            <MenuItem value={'Frau'}>Frau</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField label='Vorname' fullWidth error={!userdata?.name?.vorname} value={userdata?.name?.vorname || ''} onChange={e => setUserdata({...userdata,name:{...userdata?.name,vorname:e.target.value}})}/>
                    <TextField label='Nachname' fullWidth error={!userdata?.name?.nachname} value={userdata?.name?.nachname || ''} onChange={e => setUserdata({...userdata,name:{...userdata?.name,nachname:e.target.value}})}/>
                </Stack>
                <TextField label='Handynummer' fullWidth helperText='für dringende SMS' value={userdata?.mobile || ''} onChange={e => setUserdata({...userdata,mobile:e.target.value})}/>
                <div>
                    <Typography variant='subtitle1'>NEF-Bereiche</Typography>
                    <Bereichsauswahl selected={userdata.groups || []} disabled={true} />
                </div>
            </Stack>
        </DialogContent>
        <DialogActions>
        <Button variant="text" color="primary" onClick={(event) => close()}>abbrechen</Button>
            <Button variant="contained" color="primary" primary="true" disabled={notvalid} onClick={(event) => handleChangeSettings()}>ändern</Button>
        </DialogActions>
    </Dialog>
    )

}


function Bescheinigungen({open,close}) {
    const [axios] = useGlobal('axios')
    const [existing,setExisting] = useState([])
    const [status,setStatus] = useState('')
    const [newb,setNewb] = useState(false)
    const punkteRef = useRef()
    // Pflichtfelder, die nach Dateiauswahl noch fehlen – steuert Fehlermarkierung und Hinweistext
    const fehlend = newb?.file ? [!newb.date && 'Datum', !newb.punkte && 'CME-Punkte'].filter(Boolean) : []

    const selectFile = (file) => {
        setNewb({...newb,file:file})
        if (file && !newb.punkte) punkteRef.current?.focus()
    }

    const getlist = () => {axios.get('bescheinigungen').then(data => setExisting(data.data))}

    const getstatus = () => {axios.get('checkbeschstatus').then(data => setStatus(data.data))}
    


    useEffect(() => {
        if (open) 
            getlist()
            getstatus()
    },[open])

    const uploadBescheinigung = () => {
        if (newb) {
            const formData = new FormData();
            formData.append('date',newb.date)
            formData.append('file',newb.file,newb.file.name)
            formData.append('punkte',newb.punkte)
            axios.post('uploadBescheinigung',formData).then(r => {
            swal.fire({
              text : 'Datei hochgeladen',
             confirmButtonText: 'ok',
              })
             getlist()
             setNewb(false)
            })
            }
    }

    const deleteBescheinigung = (b) => {
        console.log(b)
    }

    // const getbescheinigung = (id) => {
    //     axios.get('getbescheinigung',{params:{_id:id},responseType:'stream'}).then(r => r.data.pipe(createWriteStream('file_name.jpg')))
    // }

    return (
        <>
        <Dialog open={open} maxWidth={'sm'} fullWidth >
            <DialogTitle>Bescheinigungen</DialogTitle>
            <DialogContent>
                <Button variant='contained' color='primary' onClick={e => setNewb({date: format(add(new Date(),{days:-1}),'yyyy-MM-dd')})}>neue Bescheinigung hochladen</Button>
                <TableContainer component={Paper}>
                    <Table sx={{minWidth:400}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Dateiname</TableCell>
                                <TableCell>Datum</TableCell>
                                <TableCell>Punke</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                <TableBody>                    
                {existing.map((b,i) => 
                <TableRow key={'beschlist'+i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component="th" scope="row"><Link target="_blank" href={'https://notarzt-heinsberg.de/api/getbescheinigung?_id='+b._id}>{b.filename}</Link></TableCell>
                    <TableCell align="right">{b.datum}</TableCell>
                    <TableCell align="right">{b.punkte}</TableCell>
                    <TableCell align="right">{b.status === 'pending' ? 'in Bearbeitung' : ''}</TableCell>
                    <TableCell align="right">{b.status === 'pending' && <DeleteOutline onClick={e => deleteBescheinigung(b._id)}/>}</TableCell>
                
                </TableRow>
                )}
                </TableBody>
                </Table>
                </TableContainer>
            {status && <Typography>Es werden noch <b>{(20-status.punkte) || '?'}</b> Punkte bis zum {format(new Date(status.ende),'d.M.y')} benötigt.</Typography>}
            </DialogContent>
            <DialogActions>
            <Button variant="contained" color="primary" primary="true" onClick={(event) => close()}>schließen</Button>
            </DialogActions>
        </Dialog>       

        <Dialog open={Boolean(newb)}>
            <DialogContent>
                <div className="file">
                
                                            <Button variant="contained" component="label">
                                            {newb?.file?.name ? newb.file.name : 'Datei hochladen'} 
                                            <input type='file' hidden onChange={e => selectFile(e.target.files[0])}/>
                                        </Button>

                <TextField label='Datum' type='date' InputLabelProps={{ shrink: true }} error={!!newb?.file && !newb.date} value={newb?.date || format(new Date(),'yyyy-MM-dd')} onChange={e => setNewb({...newb,date:e.target.value})}/>
                <TextField label='Punkte' type='number' inputRef={punkteRef} error={!!newb?.file && !newb.punkte} value={newb?.punkte ?? ''} onChange={e => setNewb({...newb,punkte:e.target.value})}/>
                </div>
                {fehlend.length > 0 && <Typography variant='body2' color='error' sx={{mx:'5px'}}>Bitte noch {fehlend.join(' und ')} eintragen, dann „hochladen“ drücken.</Typography>}
        </DialogContent>
        <DialogActions>
        <Button variant="contained" color="primary" primary="true" onClick={(event) => setNewb(false)}>abbrechen</Button>
            <Button variant="contained" color="primary" disabled={fehlend.length > 0 || !newb.file} primary="true" onClick={(event) => uploadBescheinigung()}>hochladen</Button>
        </DialogActions>
        </Dialog>
        </>
    )
    
}